import { Component } from '@angular/core';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { NgxSpinnerModule } from "ngx-spinner";

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [NgxSpinnerModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  showSpinner = true;
  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    // Mostra lo spinner all'inizio
    this.spinnerService.show();

    // Sottoscrivi allo stato dello spinner
    this.spinnerService.spinnerState$.subscribe((isVisible) => {
      this.showSpinner = isVisible;
    });
  }
}
